import { Injectable } from '@angular/core';

/**
 * Cache em memória (sessão) dos dropdowns da tela Estações.
 * Evita refazer dezenas de requisições ao sair e voltar na rota.
 */
@Injectable({
  providedIn: 'root'
})
export class EstacaoLookupCacheService {
  private readonly store = new Map<string, unknown>();

  get<T>(key: string): T | undefined {
    return this.store.get(key) as T | undefined;
  }

  set(key: string, value: unknown): void {
    this.store.set(key, value);
  }

  has(key: string): boolean {
    return this.store.has(key);
  }

  delete(key: string): void {
    this.store.delete(key);
  }
}
